import { useTranslation } from 'react-i18next';
import { COND_IDS, getContent } from '@neke/core';
import { useSession } from '../store/session';
import { Link } from 'react-router-dom';

export function About() {
  const { t } = useTranslation();
  return (
    <div className="page">
      <h1>{t('nav.about')}</h1>
      <p className="muted">{t('landing.lead')}</p>
      <p className="fine">{t('about.lead2')}</p>
      <p className="fine">{t('footer.disclaimer')}</p>
      <Link to="/test" className="btn btn-primary">
        {t('landing.cta')}
      </Link>
    </div>
  );
}

export function HowItWorks() {
  const { t } = useTranslation();
  // Шаги лежат в словаре: страница должна переключаться на казахский вместе со всем сайтом.
  const steps = ['how.s1', 'how.s2', 'how.s3', 'how.s4'];

  return (
    <div className="page">
      <h1>{t('how.title')}</h1>
      <p className="muted">{t('how.lead')}</p>
      <div className="stack">
        {steps.map((key, i) => (
          <div className="tile" key={key}>
            <span className="tile-icon">{i + 1}</span>
            <span>{t(key)}</span>
          </div>
        ))}
      </div>
      <Link to="/test" className="btn btn-primary">
        {t('landing.cta')}
      </Link>
    </div>
  );
}

/** «12 сфер» на лендинге — это и есть карта условий из теста. */
export function Spheres() {
  const { t } = useTranslation();
  const { locale } = useSession();
  const content = getContent(locale);

  return (
    <div className="page">
      <h1>{t('nav.spheres')}</h1>
      <p className="muted">{t('result.conditionsLead')}</p>
      <div className="stack">
        {COND_IDS.map((cond, i) => (
          <div className="tile" key={cond}>
            <span className="tile-icon">{i + 1}</span>
            <span>
              <b>{content.conditions[cond].title}</b>
              <span className="fine">{content.conditions[cond].hint}</span>
            </span>
          </div>
        ))}
      </div>
      <Link to="/test" className="btn btn-primary">
        {t('landing.cta')}
      </Link>
    </div>
  );
}

export function Blog() {
  const { t } = useTranslation();
  return (
    <div className="page">
      <h1>{t('nav.blog')}</h1>
      <p className="notice">Скоро здесь появятся статьи.</p>
    </div>
  );
}

export function NotFound() {
  return (
    <div className="page">
      <h1>404</h1>
      <Link to="/" className="btn btn-ghost">
        NEKE
      </Link>
    </div>
  );
}
